module.exports = __webpack_public_path__ + "static/media/iStock-1201200962.80c182d3.jpg";